import React from 'react';

export default class PermissionProvider extends React.PureComponent {
  static propTypes = {
    permissions: React.PropTypes.object,
  }

  static defaultProps = {
    permissions: {},
  }

  static childContextTypes = {
    viewable: React.PropTypes.func,
  }

  constructor(props, context) {
    super(props, context);

    this.permissions = props.permissions;
  }

  getChildContext() {
    const { permissions } = this;

    return {
      viewable(key) {
        return permissions[key.toLowerCase()] !== false;
      },
    };
  }

  render() {
    return React.Children.only(this.props.children);
  }
}



// WEBPACK FOOTER //
// ./src/permission/PermissionProvider.jsx